import { Link } from 'react-router-dom';
import { CONTACT } from '@/mocks/contactInfo';

const SERVICE_LINKS = [
  { label: 'Dératisation', href: '/deratisation-guadeloupe', desc: 'Rats, souris, mulots' },
  { label: 'Ravets & cafards', href: '/traitement-ravets-cafards-guadeloupe', desc: 'Blattes, blatte américaine' },
  { label: 'Termites', href: '/traitement-termites-guadeloupe', desc: 'Termites du bois sec' },
  { label: 'Punaises de lit', href: '/punaises-de-lit-guadeloupe', desc: 'Traitement complet' },
  { label: 'Scolopendres', href: '/scolopendres-guadeloupe', desc: 'Mille-pattes tropicaux' },
  { label: 'Moustiques', href: '/demoustication-guadeloupe', desc: 'Jardins, particuliers' },
  { label: 'Désinsectisation', href: '/desinsectisation-guadeloupe', desc: 'Traitement sur mesure' },
];

const INFO_LINKS = [
  { label: 'Tarifs transparents', href: '/tarifs' },
  { label: 'Blogue conseils', href: '/blogue' },
  { label: 'Devis gratuit', href: '/soumission' },
  { label: 'Mentions légales', href: '/mentions-legales' },
];

const ZONES = [
  'Les Abymes',
  'Baie-Mahault',
  'Le Gosier',
  'Sainte-Anne',
  'Saint-François',
  'Le Moule',
  'Petit-Bourg',
  'Pointe-à-Pitre',
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white">
      {/* Premium top CTA band */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <h3 className="font-heading font-bold text-xl md:text-2xl text-white mb-1">
                Un problème de nuisibles ?
              </h3>
              <p className="text-white/60 text-sm md:text-base">
                Intervention rapide sous 24h partout en Guadeloupe. Devis gratuit et sans engagement.
              </p>
            </div>
            <div className="flex items-center gap-3 shrink-0 w-full md:w-auto">
              <a
                href={CONTACT.phoneHref}
                className="flex-1 md:flex-none inline-flex items-center justify-center gap-2 bg-white text-primary-900 px-5 py-3.5 rounded-lg text-sm font-bold cursor-pointer whitespace-nowrap hover:bg-background-50 transition-colors"
              >
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                {CONTACT.phone}
              </a>
              <a
                href={CONTACT.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 md:flex-none inline-flex items-center justify-center gap-2 bg-whatsapp-500 hover:bg-whatsapp-600 text-white px-5 py-3.5 rounded-lg text-sm font-bold cursor-pointer whitespace-nowrap transition-colors"
              >
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 md:gap-8">
          {/* Brand column — spans 4 on large */}
          <div className="lg:col-span-4">
            <Link to="/" className="inline-flex items-center gap-3 mb-5 cursor-pointer">
              <div className="w-11 h-11 flex items-center justify-center rounded-2xl bg-mango-500 shrink-0">
                <span className="font-heading font-extrabold text-primary-700 text-xl">GN</span>
              </div>
              <div>
                <span className="font-heading font-bold text-white text-lg leading-tight block">GWADA NUISIBLES</span>
                <span className="text-white/50 text-xs font-medium tracking-wide">Dératisation & Désinsectisation</span>
              </div>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-sm">
              Experts en traitement des nuisibles à domicile en Guadeloupe. Méthodes certifiées, produits agréés, résultats garantis.
            </p>
            <div className="space-y-3">
              <a
                href={CONTACT.phoneHref}
                className="flex items-center gap-3 text-white hover:text-mango-400 text-sm cursor-pointer transition-colors group"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 group-hover:bg-white/10 transition-colors shrink-0">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-mango-400"></i>
                </div>
                <div>
                  <span className="text-white/50 text-xs block">Téléphone</span>
                  <span className="font-semibold">{CONTACT.phone}</span>
                </div>
              </a>
              <a
                href={CONTACT.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white hover:text-mango-400 text-sm cursor-pointer transition-colors group"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 group-hover:bg-white/10 transition-colors shrink-0">
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center text-whatsapp-500"></i>
                </div>
                <div>
                  <span className="text-white/50 text-xs block">WhatsApp</span>
                  <span className="font-semibold">{CONTACT.whatsapp}</span>
                </div>
              </a>
              <div className="flex items-center gap-3 text-white/70 text-sm group">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 shrink-0">
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-secondary-400"></i>
                </div>
                <div>
                  <span className="text-white/50 text-xs block">Intervention</span>
                  <span>Toute la Guadeloupe</span>
                </div>
              </div>
            </div>
          </div>

          {/* Services column */}
          <div className="lg:col-span-3">
            <h4 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-5 flex items-center gap-2">
              <span className="w-6 h-px bg-mango-400 inline-block"></span>
              Nos services
            </h4>
            <ul className="space-y-3">
              {SERVICE_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="group flex items-start gap-2 text-white/60 hover:text-white text-sm cursor-pointer transition-colors"
                  >
                    <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-white/20 group-hover:text-mango-400 group-hover:translate-x-0.5 transition-all shrink-0 mt-0.5"></i>
                    <div>
                      <span className="font-medium">{link.label}</span>
                      <span className="text-white/40 text-xs block mt-0.5">{link.desc}</span>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Infos + zones */}
          <div className="lg:col-span-3">
            <h4 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-5 flex items-center gap-2">
              <span className="w-6 h-px bg-mango-400 inline-block"></span>
              Informations
            </h4>
            <ul className="space-y-3 mb-8">
              {INFO_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="group flex items-center gap-2 text-white/60 hover:text-white text-sm cursor-pointer transition-colors"
                  >
                    <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-white/20 group-hover:text-mango-400 group-hover:translate-x-0.5 transition-all shrink-0 mt-0.5"></i>
                    <span className="font-medium">{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-secondary-400 inline-block"></span>
              Zones d&apos;intervention
            </h4>
            <div className="flex flex-wrap gap-2">
              {ZONES.map((zone) => (
                <span
                  key={zone}
                  className="inline-flex items-center px-2.5 py-1 rounded-md bg-white/5 text-white/60 text-xs font-medium border border-white/5"
                >
                  {zone}
                </span>
              ))}
            </div>
          </div>

          {/* Trust / badges column */}
          <div className="lg:col-span-2">
            <h4 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-5 flex items-center gap-2">
              <span className="w-6 h-px bg-secondary-400 inline-block"></span>
              Confiance
            </h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 shrink-0">
                  <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-secondary-400"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-medium">Produits certifiés</p>
                  <p className="text-white/50 text-xs">Agréés CTBA</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 shrink-0">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center text-secondary-400"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-medium">Intervention 7j/7</p>
                  <p className="text-white/50 text-xs">Urgences 24h/24</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 shrink-0">
                  <i className="ri-award-line w-4 h-4 flex items-center justify-center text-secondary-400"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-medium">Garantie résultat</p>
                  <p className="text-white/50 text-xs">Satisfaction assurée</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 shrink-0">
                  <i className="ri-leaf-line w-4 h-4 flex items-center justify-center text-secondary-400"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-medium">Respectueux</p>
                  <p className="text-white/50 text-xs">Environnement & animaux</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Gwada Nuisibles. Tous droits réservés. SIRET en cours d&apos;immatriculation.
          </p>
          <div className="flex items-center gap-4 text-white/40 text-xs">
            <span className="hidden sm:inline">Intervention à domicile partout en Guadeloupe</span>
            <div className="flex items-center gap-3">
              <a
                href={CONTACT.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white/60 transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <span className="w-px h-3 bg-white/20"></span>
              <Link
                to="/mentions-legales"
                className="hover:text-white/60 transition-colors cursor-pointer"
              >
                Mentions légales
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}